import React from 'react';
import Header from '../components/Header';
import Products from '../components/Products';
const ShopDetailPage = () => {
    return(
        <div>
            <Header />
            <div className="container">
            <h1 className="text-center display-1" style={{marginLeft:"4%",marginRight:"2%", width:"90%"}}>ACHAYANTE ADUKALA</h1>
            <Products />
            </div>
        </div>
    );
};

export default ShopDetailPage;